import { render, staticRenderFns } from "./ProdutosForaEncarte.vue?vue&type=template&id=0512d4cc"
import script from "./ProdutosForaEncarte.vue?vue&type=script&lang=js"
export * from "./ProdutosForaEncarte.vue?vue&type=script&lang=js"
import style0 from "./ProdutosForaEncarte.vue?vue&type=style&index=0&id=0512d4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports